export default __webpack_public_path__ + "static/media/main-how-it-works-us-tests.8499d57a.png";